@if (isAdmin() || !hideWhenEmpty() || selectedCount() > 0) {
  <div class="multi-select-sidebar" [class.multi-select-sidebar--admin]="isAdmin()">
    <p class="multi-select-sidebar__title">
      {{ selectedCount() }} {{ titleSuffix() }}
      @if (showSelectionInfo() && (isAdmin() || selectedItemsLabel())) {
        <mat-icon
          (mouseover)="isOpen = true"
          (mouseout)="isOpen = false"
          cdkOverlayOrigin
          #trigger="cdkOverlayOrigin"
          color="accent"
        >
          info
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayOpen]="isOpen"
          >
            <mat-card class="multi-select-sidebar__card">
              <mat-card-content class="multi-select-sidebar__info">
                <p>{{ selectedItemsLabel() }}</p>
              </mat-card-content>
            </mat-card>
          </ng-template>
        </mat-icon>
      }
    </p>

    @for (action of actionItems(); track action.id) {
      @if (!action.hidden) {
        <button
          mat-button
          class="{{
            isAdmin() ? 'multi-select-sidebar__action-button' : 'multi-select-sidebar__button'
          }} {{ action.className ?? '' }}"
          [disabled]="!!action.disabled"
          [color]="action.color"
          [matTooltip]="action.tooltip ?? ''"
          [matTooltipDisabled]="!action.tooltip"
          (click)="onActionClicked(action.id, action.disabled)"
        >
          @if (action.svgIcon) {
            <mat-icon [svgIcon]="action.svgIcon" [color]="action.iconColor"></mat-icon>
          } @else if (action.icon) {
            <mat-icon [color]="action.iconColor">{{ action.icon }}</mat-icon>
          }
          {{ action.label }}
        </button>
      }
    }
    <ng-content />
  </div>
}
